/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFilePlay: {
  name: 'file-play';
  data: string;
} = {
  name: 'file-play',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 2A1.5 1.5 0 0 1 4 .5h4.586a1.5 1.5 0 0 1 1.06.44l3.415 3.414a1.5 1.5 0 0 1 .439 1.06V9a.5.5 0 0 1-1 0V5.5H10A1.5 1.5 0 0 1 8.5 4V1.5H4a.5.5 0 0 0-.5.5v7a.5.5 0 0 1-1 0V2Zm7 .207V4a.5.5 0 0 0 .5.5h1.793L9.5 2.207ZM4.725 8.583a.5.5 0 0 1 .472-.043l7 3a.5.5 0 0 1 0 .92l-7 3A.5.5 0 0 1 4.5 15V9a.5.5 0 0 1 .225-.417Zm.775 5.659L10.73 12 5.5 9.758v4.484Z" fill="currentColor"/></svg>`,
};
